import Api from '../utilities/Api';

const SubscribeService = {
    subscribeByEmail(email, rubrics = []) {
        return Api.post('/api/subscription/email/', {
            email,
            rubrics
        }).then((response) => {
            return response;
        });
    },
};

export default SubscribeService;
